export class TruffleFound {
  id: number;
  foundAt: string = new Date().toString();
  weight: number;
  quality: string;
}
